import React from 'react'
import { FiGithub, FiInstagram } from 'react-icons/fi'
import { FaLinkedinIn } from 'react-icons/fa'

const Social = () => {
  return (
    <div className="social-container flex">
        <a href='https://github.com/DenisSemko' target="_blank" rel="noreferrer"><FiGithub className='icon' /></a>
        <a href='https://www.instagram.com/denys.semko' target="_blank" rel="noreferrer"><FiInstagram className='icon' /></a>
        <a href='https://www.linkedin.com/in/denis-semko-551b91191' target="_blank" rel="noreferrer"><FaLinkedinIn className='icon' /></a>
    </div>     
  )
}

export default Social